import { IAAPDEvent } from '../../classes/event';
import * as moment from 'moment';

export enum ActionType {
    UPSERT_FILTER,
    STORE_FILTERED_MEDIA,
    REMOVE_FILTER,
    REMOVE_ALL_FILTERS,
    REQUEST_NEXT_BATCH,
    RECEIVE_NEXT_BATCH,
    FILTER_EVENTS,
    RECEIVE_FILTERS,
    SET_CONTENT,
    INCREMENT_MONTH,
    DECREMENT_MONTH,
    TOGGLE_VIEW
};

export function setContent(content: IAAPDEvent) {
    return {
        type: ActionType.SET_CONTENT,
        value: content
    }
}

export function decrementMonth() {
    return {
        type: ActionType.DECREMENT_MONTH,
        value: true
    }
}

export function incrementMonth() {
    return {
        type: ActionType.INCREMENT_MONTH,
        value: true
    }
}

export function filterEventsByCategory(category: string) {
    return {
        type: ActionType.FILTER_EVENTS,
        value: category
    }
}

export function toggleCalendarView(selectedView: string) {
    return {
        type: ActionType.TOGGLE_VIEW,
        value: selectedView
    }
}




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/redux/actions/actions.ts